const convertThDateStringToDateString = (thDateString) => {
    const thDateArray = thDateString.split(' ')
	const day = thDateArray[0]
	const monthTh = thDateArray[1]
	const yearTh = '25'+thDateArray[2]
	const thMonthShort = ['', 'ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.' ]
    if( thMonthShort.indexOf(monthTh) < 0 ){
        return null;
    }
    let numMonth = thMonthShort.indexOf(monthTh)
    numMonth = numMonth < 10 ? "0" + numMonth : numMonth
    const numDay = day < 10 ? "0" + day : day
	const yearEn = parseInt(yearTh) - 543
    const dateStr = `${yearEn}-${numMonth}-${numDay}`;
    return dateStr
}

export default convertThDateStringToDateString;